<template>
  <!-- 推荐人列表 -->
  <div
    style="min-width:1200px;"
    class="big"
  >
    <div class="page_title">推荐人列表</div>
    <div style="padding:20px;">
      <div class="container">
        <!-- 筛选项 -->

        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">邀请码</div>
            <el-input
              v-model="recommender_code"
              size="small"
              style="width:100px"
            />
          </div>
          <div class="box flex">
            <div class="label">推荐人姓名</div>
            <el-input
              v-model="recommender_name"
              size="small"
              style="width:100px"
              @input="search"
            />
          </div>
          <div class="box flex">
            <div class="label">医生姓名</div>
            <el-input
              v-model="doctor_name"
              size="small"
              style="width:100px"
              @input="search"
            />
          </div>
          <div class="box flex">
            <div class="label">医院名称</div>
            <el-input
              v-model="hospital"
              size="small"
              style="width:120px"
              @input="search"
            />
          </div>
          <div class="box flex">
            <div class="label">医生手机号</div>
            <el-input
              v-model="phone"
              size="small"
              style="width:130px"
            />
          </div>

          <el-button
            type="info"
            class="search-button"
            @click="search"
            size="small"
          >查询</el-button>
          <el-button
            type="primary"
            @click="addCode"
            size="small"
            :disabled="module_id_array[0]?!module_id_array.includes('403'):false"
          >添加邀请码</el-button>
        </div>

        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">推荐人手机号</div>
            <el-input
              v-model="recommender_phone"
              size="small"
              style="width:130px"
            />
          </div>
          <div
            class="box flex"
            style="align-items:center"
          >
            <el-radio
              v-model="is_maintain"
              :label="0"
              @change="search"
            >全部</el-radio>
            <el-radio
              v-model="is_maintain"
              :label="1"
              @change="search"
            >已维护</el-radio>
            <el-radio
              v-model="is_maintain"
              :label="2"
              @change="search"
            >未维护</el-radio>
          </div>
          <div
            class="box flex"
            style="align-items:center"
          >
            <span style="margin-right:20px">是否测试医生</span>
            <el-radio
              v-model="is_test"
              :label="0"
              @change="search"
            >全部</el-radio>
            <el-radio
              v-model="is_test"
              :label="1"
              @change="search"
            >是</el-radio>
            <el-radio
              v-model="is_test"
              :label="2"
              @change="search"
            >否</el-radio>
          </div>
        </div>
        <!-- 表格 -->
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1200px;"
            :header-cell-style="{background:'#F5F5F5'}"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              prop="recommender_code"
              label="邀请码"
              width="150"
            />
            <el-table-column label="推荐人姓名">
              <template slot-scope="scope">
                <span
                  :class="scope.row.recommender_name?'':'red'">{{scope.row.recommender_name||'未维护'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="推荐人手机号"
            />
            <el-table-column
              label="医生姓名"
              prop="doctor_name"
              class-name="border-column"
              align="center"
            />
            <el-table-column
              label="手机号"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  :class="scope.row.doctor_phone?'':'red'"
                  v-if="scope.row.doctor_phone!='查看更多'"
                >{{scope.row.doctor_phone||'未绑定'}}</span>
                <span
                  class="main-color"
                  style="cursor:pointer"
                  v-if="scope.row.doctor_phone=='查看更多'"
                  @click="showMore(scope.row)"
                >查看更多</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="hospital"
              label="医院名称"
            />
            <el-table-column
              label="操作"
              class-name="border-column"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toReferrerDesc(scope.row.recommender_code)"
                  :disabled="module_id_array[0]?!module_id_array.includes('142'):false"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增医生弹窗 -->
    <el-dialog
      title="更多绑定医生"
      :visible.sync="extraShow"
      width="600px"
      style="text-align:left"
      center
    >
      <div style="padding:20px">
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            :data="extraData"
            tooltip-effect="dark"
            style="width: 100%;"
            height="600px"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            />
            <el-table-column
              prop="doctor_phone"
              label="手机号"
            />
            <el-table-column
              prop="hospital"
              label="医院名称"
            />
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data() {
    return {
      recommender_code: '',
      recommender_name: '',
      recommender_phone: '',
      doctor_name: '',
      hospital: '',
      phone: '',
      is_maintain: 0,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      extraShow: false,
      extraData: [],
      is_test: 0
    };
  },
  activated() {
    this.getList();
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取认证记录列表
    getList() {
      let data = {
        recommender_code: this.recommender_code,
        recommender_name: this.recommender_name,
        recommender_phone: this.recommender_phone,
        doctor_name: this.doctor_name,
        hospital: this.hospital,
        is_maintain: this.is_maintain,
        phone: this.phone,
        page: this.currentPage,
        pageNumber: this.pagesize,
        is_test: this.is_test
      };
      this.axios
        .post('platform/activity/getRecommenderList', data)
        .then((res) => {
          this.totalNum = res.data.total;
          this.fomartList(res.data.list);
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //格式化获取的推荐人列表
    fomartList(list) {
      let arr = [];

      list.forEach((ele) => {
        if (ele.doctor_list || ele.doctor_list.length > 0) {
          let children = [];
          ele.doctor_list.forEach((docInfo, index) => {
            let obj = {
              recommender_code: ele.recommender_code,
              recommender_name: ele.recommender_name,
              recommender_phone: ele.phone,
              phone: ele.phone,
              doctor_name: docInfo.doctor_name,
              doctor_phone: docInfo.phone,
              hospital: docInfo.hospital
            };
            if (index <= 9) {
              arr.push(obj);
              children.push(obj);
            } else {
              children.push(obj);
            }
          });
          if (ele.doctor_list.length > 10) {
            let obj = {
              recommender_code: ele.recommender_code,
              recommender_name: ele.recommender_name,
              phone: ele.phone,
              doctor_phone: '查看更多',
              children: children
            };
            arr.push(obj);
          }
        } else {
          ele.doctor_name = '';
          ele.doctor_phone = '';
          ele.hospital = '';
          arr.push(ele);
        }
      });
      this.tableData = arr;
    },
    //合并表格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 0;
      if (
        columnIndex == 0 ||
        columnIndex == 1 ||
        columnIndex == 2 ||
        columnIndex == 6
      ) {
        this.tableData.forEach((ele) => {
          if (row.recommender_code == ele.recommender_code) {
            num++;
          }
        });
      }
      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].recommender_code ==
            this.tableData[rowIndex - 1].recommender_code
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: num,
            colspan: 1
          };
        }
      }
    },
    //超过10个时查看更多
    showMore(row) {
      this.extraShow = true;
      this.extraData = row.children;
    },
    toReferrerDesc(code) {
      this.$router.push({
        path: '/home/activity/referrerDesc',
        query: { recommender_code: code }
      });
    },
    //添加邀请码
    addCode() {
      let validator = (value) => {
        let reg = /^([A-Za-z\d])*$/;
        if (!reg.test(value)) {
          return '请输入数字或字母';
        }
        if (value.length > 10) {
          return '请输入10位以内字符';
        }
      };
      this.$prompt('', '添加邀请码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: validator,
        inputErrorMessage: '格式不正确',
        closeOnClickModal: false
      })
        .then(({ value }) => {
          let recommender_code = value;
          this.axios
            .post('platform/activity/addInvitationCode', { recommender_code })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('添加成功');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
</style>
<style lang="scss">
.border-column {
  border-left: 1px solid #ebeef5;
}
</style>


